import { Link } from '@inertiajs/react';

export default function WebNavbar({ children }: { children?: HTMLElement | React.ReactNode }) {
    return (
        <div className="relative w-full bg-gray-800 bg-linear-to-br from-gray-900 to-gray-950">
            {/* --- NAVBAR --- */}
            <nav className="bg-gray-100 border-b border-zinc-100 sticky top-0 z-50 bg-linear-to-b from-gray-300 to-gray-100">
                <div className="w-full pb-0 pt-1 px-2 sm:px-4 lg:px-4">
                    <div className="flex justify-between h-auto
                    ">
                        
                        {/* Logo a la izquierda */}
                        <div className="shrink-0 flex items-center">
                            
                            <Link href="/">
                                <img 
                                    className="h-16 md:h-20 lg:h-20 xxl:h-24  w-auto p-1"
                                    src="/pictures/GaredTech_Tipografia.png" // Asegúrate de tener esta imagen en public/images/
                                    alt="Logo"
                                />
                            </Link>
                        </div>

                        {/* Espacio vacío a la derecha */}
                        <div className="flex items-center">
                            {/* Aquí irán botones o menú de usuario luego */}
                            <Link href="/">
                                <div className="text-gray-500 hover:text-gray-700 px-3 py-2 rounded-md font-bold">
                                    Inicio
                                </div>
                            </Link>
                            <div className="shrink-0 flex items-center">
                            <Link href="/contacto">
                                <div className="text-gray-500 hover:text-gray-700 px-3 py-2 rounded-md font-bold">
                                    Contacto
                                </div>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

        </div>
    );
}